import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useForm } from './form';
export const withFormData = (Component) => {
    return (props) => {
        let formProps = {};
        try {
            const { formData, validationErrors, setFormData } = useForm();
            const error = validationErrors[props.name];
            formProps = {
                value: (props.name && formData[props.name]) || '',
                error: (props.name && Boolean(error?.key)) || undefined,
                helperText: (props.name && error?.key) ?? '',
                onChange: (event, maybeValue) => {
                    let value = event.target.value;
                    if (!React.isValidElement(maybeValue)) {
                        value = maybeValue || value;
                    }
                    setFormData((prev) => (props.name ? { ...prev, [props.name]: value } : prev));
                },
            };
        }
        catch (error) {
            // no form data
        }
        return _jsx(Component, { ...formProps, ...props });
    };
};
